import React from 'react';
import { ApolloError } from '@apollo/client';
import { FormRenderProps } from 'react-final-form';

import { Container, PageHeader, useAppLayoutContextConsumer } from '@occc-app/design-system';

import { UpdateProductCategoryForm } from './UpdateProductCategoryForm';
import { breadcrumbLinks } from './constants';

import { FormContent } from '../components/FormContent';

interface UpdateProductCategoryFormRenderComponentProps
  extends Pick<FormRenderProps, 'handleSubmit'> {
  disabled: boolean;
  loading: boolean;
  loaded: boolean;
  error?: ApolloError;
}

export const UpdateProductCategoryFormRenderComponent: React.FC<
  UpdateProductCategoryFormRenderComponentProps
> = ({ handleSubmit, disabled, loading, loaded, error }) => {
  useAppLayoutContextConsumer(breadcrumbLinks);

  // TODO: move Container and PageHeader to level up and replace it along with Helmet by Page component
  return (
    <Container variant='md' includesPageHeader>
      <PageHeader title='Update Product Preference' />
      <UpdateProductCategoryForm
        loading={loading}
        loaded={loaded}
        error={error}
        handleSubmit={handleSubmit}
        disabled={disabled}
      >
        <FormContent />
      </UpdateProductCategoryForm>
    </Container>
  );
};
